export interface BulkValidationDetails {
  processed: number,
  total: number,
  percentage: number,
  startTime: string, // ISO date time
  endTime: string, // ISO date time
  lastUpdateTime: string, // ISO date time
  status: BulkValidationStatus
}

export interface BulkValidationPayload {
  locationIds: number[],
  action: 'VALIDATE' | 'INVALIDATE'
  pinSource?: 'IMPORT' | 'GEOCODE' // provide if action = VALIDATE
}

export enum BulkValidationStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  IDLE = 'IDLE' // logs are stored for max 30 days
}